import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Home — house outline for the Home tab. */
export function HomeIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M4 11.5 12 4l8 7.5" />
      <path d="M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9" />
      <path d="M10 20v-5h4v5" />
    </PortalIcon>
  );
}
